export const isString = (s: any) => typeof s === "string";

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

/**
 * This function will convert text that containts html to plain text
 * @param htmlString
 * @returns
 */
export function htmlToPlainText(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || "";
}

/**
 * This funciton will check if a string contains html
 * @param str
 * @returns
 */
export function containsHTML(str: string) {
  const htmlPattern = /<\/?[a-z][\s\S]*>/i;
  return htmlPattern.test(str);
}
